import {FilterTypes} from 'modules/policy/constants';

export enum PolicyAgentFilterTypes {
  PLATFORMS = 'platforms',
  PUBLISHERS = 'publishers',
  STATUSES = 'statuses',
}

// Mapping for singular names in filter types
export const AgentPolicyFilterTypeMap = {
  [PolicyAgentFilterTypes.PLATFORMS]: FilterTypes.PLATFORM,
  [PolicyAgentFilterTypes.PUBLISHERS]: FilterTypes.PUBLISHER,
  [PolicyAgentFilterTypes.STATUSES]: FilterTypes.ASSESSMENT_STATUS,
} as const;

export type FilterValueWithCount = {value: string; count: number};

export type PolicyAgentFilters = {
  [PolicyAgentFilterTypes.PLATFORMS]: FilterValueWithCount[];
  [PolicyAgentFilterTypes.PUBLISHERS]: FilterValueWithCount[];
  [PolicyAgentFilterTypes.STATUSES]: FilterValueWithCount[];
};

export type SelectedPolicyAgentFilters = {
  [PolicyAgentFilterTypes.PLATFORMS]: string[];
  [PolicyAgentFilterTypes.PUBLISHERS]: string[];
  [PolicyAgentFilterTypes.STATUSES]: string[];
  showDeprecatedPolicies: boolean;
};
